import { render, staticRenderFns } from "./MForm.vue?vue&type=template&id=02cb66cd&scoped=true"
import script from "./MForm.vue?vue&type=script&lang=js"
export * from "./MForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cb66cd",
  null
  
)

export default component.exports